<!-- shared/components/customer-select/customer-select.component.html -->
<div class="customer-select">
  <ng-container *ngIf="!noAssignableCustomers; else noCustomerTpl">

    <select class="form-control form-select" [value]="customerId" (change)="onSelectChange($event)">
      <option value="">Select a customer</option>
      <option *ngFor="let c of results" [value]="c._id">
        {{ c.name }}
      </option>
    </select>

  </ng-container>

  <ng-template #noCustomerTpl>
    <div class="form-text text-muted">
      There are no customers assigned to you.
      Please contact your administrator.
    </div>
  </ng-template>
</div>